import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';

const PageTransition = () => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  
  // Reset loading state on route change
  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    
    return () => clearTimeout(timer);
  }, [location.pathname]);
  
  if (!isLoading) return null;
  
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        backdropFilter: 'blur(8px)',
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
      }}
    >
      <Box
        component="img"
        src="/images/ani-wtt.gif"
        alt="Loading"
        sx={{
          maxWidth: '200px',
          maxHeight: '200px',
          mixBlendMode: 'multiply', // This helps remove white backgrounds
          filter: 'contrast(1.1)', // Slightly increase contrast to improve visibility
        }}
      />
    </Box>
  );
};

export default PageTransition;
